module.exports = __webpack_public_path__ + "zhongxin.jpg?1bef8deff004891ac871154207980f64";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/zhongxin.jpg
// module id = 74
// module chunks = 0